import { Button, Form, Modal, Input, Select, message } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { useAppDispatch } from '../../methods/redux/hooks';
import { commas } from '../../methods/utils/general-utils';
import {
	deleteLocalSwapRate,
	editLocalSwapRate,
} from '../../methods/redux/reducers/swap';
import {
	getVirtualAccountBySafeHavenId,
	getVirtualTransaction,
} from '../../methods/redux/reducers/payment-gateway';

interface ISwapProtocolItem {
	data: any;
	setRefresh: Function;
	currencySelect: any;
}

const Styles = styled.div`
	display: flex;
	justify-content: space-between;
	background-color: #f8f8f8;
	padding: 20px;
	margin-bottom: 5px;
	& .text {
		font-size: 13px;
	}
	& .texts:hover {
		color: grey;
		text-decoration: underline;
		transform: scale(1.02);
		transition: transform 0.2s;
	}

	& .label {
		font-size: 11px;
		color: #808080;
		font-style: italic;
	}
`;

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

const VirtualFiatAccountItems = ({
	data,
	setRefresh,
	currencySelect,
}: ISwapProtocolItem) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isVirtualAccountModalVisible, setIsVirtualAccountModalVisible] =
		useState(false);

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
	};

	const handleVirtualAccountModalCancel = () => {
		setIsVirtualAccountModalVisible(false);
	};

	const handleGetVirtualTransaction = async () => {
		setIsVirtualAccountModalVisible(false);
		setLoading(true);
		try {
			await dispatch(getVirtualTransaction(data?.virtualId));
			navigate(
				`/core-modules/virtual-fiat-accounts/safe-haven/transaction/${data?.virtualId}`
			);
		} catch (error: any) {
			message.error(
				error?.response?.data?.message ||
					'Failed to fetch virtual transaction details'
			);
		} finally {
			setLoading(false);
		}
	};

	const handleGetVirtualAccountBySafeHavenId = async () => {
		setIsVirtualAccountModalVisible(false);
		setLoading(true);
		try {
			await dispatch(getVirtualAccountBySafeHavenId(data?.virtualId));
			navigate(
				`/core-modules/virtual-fiat-accounts/safe-haven/${data?.virtualId}`
			);
		} catch (error: any) {
			message.error(
				error?.response?.data?.message ||
					'Failed to fetch virtual account details'
			);
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);
			const jobData = {
				baseCurrencyId: values.baseCurrencyId,
				quoteCurrencyId: values.quoteCurrencyId,
				rate: values.rate,
				volume: values.volume,
			};
			await dispatch(editLocalSwapRate({ id: data?._id, data: jobData }));
			handleCancel();
			form.resetFields();
			setRefresh(Math.random());
		} catch (error: any) {
			message.error(error?.response?.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Styles>
			{/* <div>
				<p>{data?.userId?.email}</p>
				<p className="label">Email</p>
			</div> */}
			<div>
				<p
					className="texts"
					onClick={() => navigate(`/user-profile/${data.userId?._id}`)}
					style={{ cursor: 'pointer' }}
				>
					{data?.userId?.username}
				</p>
				<p className="label">UserName</p>
			</div>
			<div>
				<p className="text">{data?.accountName}</p>
				<p className="label">Account Name</p>
			</div>
			{data?.accountNumber && (
				<div>
					<p className="text">{data?.accountNumber}</p>
					<p className="label">Account Number</p>
				</div>
			)}

			<div>
				<p className="text">{data?.providerKey}</p>
				<p className="label">Provider Key</p>
			</div>
			{/* 
			{data?.referenceId && (
				<div>
					<p className="text">{data?.referenceId}</p>
					<p className="label">Reference Id</p>
				</div>
			)} */}
			{data?.virtualId && (
				<div>
					<p
						className={data?.providerKey === 'SAFE_HAVEN' ? 'texts' : 'text'}
						onClick={
							data?.providerKey === 'SAFE_HAVEN'
								? () => {
										setIsVirtualAccountModalVisible(true);
								  }
								: undefined
						}
						onKeyDown={
							data?.providerKey === 'SAFE_HAVEN'
								? (e) => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault();
											setIsVirtualAccountModalVisible(true);
										}
								  }
								: undefined
						}
						role={data?.providerKey === 'SAFE_HAVEN' ? 'button' : undefined}
						tabIndex={data?.providerKey === 'SAFE_HAVEN' ? 0 : undefined}
						style={
							data?.providerKey === 'SAFE_HAVEN'
								? { cursor: 'pointer' }
								: undefined
						}
					>
						{data?.virtualId}
					</p>
					<p className="label">Virtual Account Id</p>
				</div>
			)}

			{/* <div>
				<p>{data?.settlementWalletId || 'N/A'}</p>
				<p className="label">Settlement Wallet Id</p>
			</div> */}
			<div>
				{' '}
				<p className="text">{data?.bankName}</p>
				<p className="label">Bank Name</p>
			</div>
			<div>
				<p>
					{' '}
					<p className="text">{data?.countryCode}</p>
				</p>
				<p className="label">Country Code</p>
			</div>
			<div>
				<p>
					{' '}
					<p className="text">{data?.status}</p>
				</p>
				<p className="label">Status</p>
			</div>

			<div>
				<p className="text">{commas(data.expectedAmount)}</p>
				<p className="label">Profit</p>
			</div>
			<div>
				<p className="text">
					{moment(data.createdAt).format('MMM DD, YY / hh:mm:ss a')}
				</p>
				<p className="label">Created At</p>
			</div>
			{/* <div>
				<p>{moment(data.updatedAt).format('MMM DD, YY / hh:mm:ss a')}</p>
				<p className="label">Updated At</p>
			</div> */}

			{/* <div>
				<p>
					{moment(data.shortLivedExpiryTime).format('MMM DD, YY / hh:mm:ss a')}
				</p>
				<p className="label">Short Lived Expiry Time</p>
			</div> */}
			<Modal
				title="Virtual Account Actions"
				open={isVirtualAccountModalVisible}
				onCancel={handleVirtualAccountModalCancel}
				footer={null}
			>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
					<Button type="primary" block onClick={handleGetVirtualTransaction}>
						Get Virtual Transaction
					</Button>
					<Button
						type="default"
						block
						onClick={handleGetVirtualAccountBySafeHavenId}
					>
						Get Virtual Account By SafeHaven ID
					</Button>
				</div>
			</Modal>
		</Styles>
	);
};

export default VirtualFiatAccountItems;
